import Swiper from 'swiper';

class customCarousel extends HTMLElement {
    constructor() {
        super();
  
        const popularProductsSwiper = sliderElm => {
            return new Swiper(sliderElm, {
                freeMode: true,
                slidesPerView: 1.2,
                spaceBetween: 10,
                preventClicks: true,
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 10,
                        preventClicks: true,
                    },
                }
            });
        }

        const allSliders = document.querySelectorAll('.popular-products-swiper');
        allSliders.forEach(slider => popularProductsSwiper(slider));
    }
}
  
customElements.define('custom-carousel', customCarousel);